import type { RootState } from 'src/app/store/types';

export function selectTripLocations(state: RootState) {
  return state.tripSummary.tripLocations;
}
